import { TOTAL_CLIENTS } from '@propertypal/shared/src/constants/products';
import dayjs from '@propertypal/shared/src/services/dayjs';
import Button from '@propertypal/web-ui/src/buttons/Button';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import React from 'react';
import { useTheme } from 'styled-components';
import {
  BasePlate,
  Container,
  Content,
  ContentText,
  ContentTextWraper,
  Laptop,
  LaptopImage,
} from './FeaturedContent.style';
import { GradientBgAngle } from './SuperFeature.style';

interface FeaturedContentProps {
  dev?: boolean;
}

const FeaturedContent: React.FC<FeaturedContentProps> = ({ dev }) => {
  const theme = useTheme();

  return (
    <Container>
      <PageWrapper>
        <Content>
          <Laptop>
            <BasePlate>
              <LaptopImage dev={dev} />
            </BasePlate>
          </Laptop>
          <ContentText>
            <SubHeading mb={25} fontSize={60}>
              Experienced website providers in NI…
            </SubHeading>
            <ContentTextWraper>
              <Text>
                Benefit from {dayjs().diff(dayjs(new Date(2008, 1, 1)), 'y')} years of expertise and{' '}
                <strong>{TOTAL_CLIENTS}+</strong> successfully built websites.
              </Text>
              <Text>
                Each of our websites offer the latest cutting-edge, technology, providing innovative solutions that push
                boundaries.
              </Text>
            </ContentTextWraper>
            <Button
              onClick={() => document.getElementById('getInTouch')?.scrollIntoView({ behavior: 'smooth' })}
              maxWidth="300px"
              testID="scroll-to-button"
            >
              Let&apos;s chat
            </Button>
          </ContentText>
        </Content>
      </PageWrapper>
      <GradientBgAngle color={theme.white} reverse />
    </Container>
  );
};

export default FeaturedContent;
